import { render } from "./auditHistoryCompany.vue?vue&type=template&id=b20cbc0a&scoped=true"
import script from "./auditHistoryCompany.vue?vue&type=script&lang=js"
export * from "./auditHistoryCompany.vue?vue&type=script&lang=js"

import "./auditHistoryCompany.vue?vue&type=style&index=0&id=b20cbc0a&scoped=true&lang=scss"

import exportComponent from "H:\\Environment_蓝宇\\Src\\GZXY\\GZEUA\\GZ_CQ_V2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b20cbc0a"]])

export default __exports__